import { useMemo } from 'react'

interface PackOption {
    PackID: number
    Pack_Name?: string
    [key: string]: any
}

// Ensures the item's default pack (PackID/Pack_Name) is present in the list, so a
// locked pack-select can still display the selected value when the default isn't
// among AvailablePacks. No-op when there is no default or it's already in the list.
export const useAvailablePacksWithDefault = (
    availablePacks: PackOption[] = [],
    PackID?: number,
    Pack_Name?: string,
): PackOption[] =>
    useMemo(() => {
        if (PackID && !availablePacks.some((p) => p.PackID === PackID)) {
            return [...availablePacks, { PackID, Pack_Name }]
        }
        return availablePacks
    }, [availablePacks, PackID, Pack_Name])
